export default function PageHero({ eyebrow, title, subtitle, image, align = 'left', children, className = '' }) {
  const heroStyle = image ? { '--page-hero-image': `url("${image}")` } : undefined;

  return (
    <section
      className={`page-hero page-hero--${align} ${className}`.trim()}
      style={heroStyle}
    >
      <div className="container page-hero-inner">
        {eyebrow && <span className="page-hero-eyebrow">{eyebrow}</span>}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
        {children && <div className="page-hero-meta">{children}</div>}
      </div>
    </section>
  );
}
